import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import { toast } from "react-toastify";
import TickIconBlack from "../../assets/img/tick-icon-black.png";
// import CrossIcon from '../assets/img/cross-icon.png';
import UploadIcon from "../../assets/img/upload-icon.svg";
import ExclamationIcon from "../../assets/img/exclamation-mark-icon.svg";
// import ArrowRightIcon from '../assets/img/arrow-right-icon.png';
// import InputFieldAddress from "./InputFieldAddress";

//this is import just to grab upload file functionality
import { uploadFileViaMultipart } from "../../Actions/personalDetailsActions";
import ABSelect from "../Common/ABSelect";
import AddressCheckbox from "./addressCheckbox";
import ABSelectAddress from "../Common/ABSelectAddress";
import Loader from "../Common/loader";
import {
  dateFormat,
  validatePincode,
  validatePincodeNew,
} from "../../Helper/common";
import { dateFormat2 } from "../../Helper/common";
import {
  getAddress,
  addAddress,
  removeAddress,
  saveAddress,
  deleteSaveAddress,
  validateAddress,
  deleteValidateAddress,
} from "../../Actions/addressActions";
import { getData } from "../../Actions/landingAction";
import { useDispatch, useSelector } from "react-redux";
import GetMasterData from "../../Helper/masterData";
import ABYear from "../Common/ABYear";
import ABDateAddress from "./ABDateAddress";
import ABMonthYear from "../Common/ABMonthYear";
import ABUpload from "../Common/ABUpload";
import ABUploadAdd from "../Common/ABUploadAdd";
import ABTextEdu from "../Common/ABTextEdu";
import ABCarousel from "../ABCarousel";
import "../../assets/css/custom-modal.css";
import "../../assets/css/rec-carousel.css";
import CustomPopUp from "../Common/customPopUp";
import { getCarousel } from "../../Actions/carouselAction";
import { useNavigate, useHistory, Link } from "react-router-dom";
import { getPincode, deletePinCode } from "../../Actions/pincodeAction";

import ABRadioAddress from "./ABRadioAddress";
import AddressSelect from "./addressSelect";
import AddSimpleSelect from "./addSimpleSelect";
import AddSimpleSelectCountry from "./addSimpleSelectCountry";
import ConfirmationPopup from "./confirmationPopup";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

const MainForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    edu,
    active,
    reference,
    showPermanentQues,
    showPermanentQuesOptions,
    showProfilePreview,
    countries,
    showAddPopup,
    closeAddPopup,
    proceedAdd,
    checkStatus,
    setLastRecordData,
    lastRecordData,
    deleteCheckCallback
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState([]);
  //state used for form fields
  const [formVal, setFormVal] = useState({});
  const [formError, setFormError] = useState({});
  //state used for custom form fields that is formatted for sending data as per the api
  const [checkDataRecord, setCheckDataRecord] = useState({});

  const [newRecord, setNewRecord] = useState({});
  const [newValidationRecord, setNewValidationRecord] = useState({});

  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(0);

  //setting state for checkox

  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [documnetMandatory, setDocumnetMandatory] = useState({});

  const [countryList, setCountryList] = useState([]);

  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [checkIdToBeRemoved, setCheckIdToBeRemoved] = useState(null);

  const [showValidationPopup, setShowValidationPopup] = useState(false);

  const [validationPopupTitle, setValidationPopupTitle] = useState("");
  const [validationPopupHeading, setValidationPopupHeading] = useState("");

  const [errorMessage, setErrorMessage] = useState(false);
  const [verificationSourceId, setVerificationSourceId] = useState();

  const [isAddressValidation, setIsAddressValidation] = useState(null);

  const [checkForAddAddress, setCheckForAddAddress] = useState(true);

  const [isAddressConfirm, setIsAddressConfirm] = useState({});

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }


  //setting address data
  useEffect(() => {
    setAddress(edu);
    setCatchIfAnyStatusIsNotCompleted(0);
    setShowValidationPopup(false);
    dispatch(deleteValidateAddress());
    setIsAddressValidation(edu.is_address_validation);

    const checksDetails = edu.checksDetails;

    getUploadedFilesCount(checksDetails);
    getDocumentIdMandatory(checksDetails);
    setCheckForAddAddress(true);
    setLastRecordData(null);
  }, [edu]);

  useEffect(() => {
    if (countries?.length) {
      const onlyForeignCountries = [
        ...countries.filter((country) => country?.label !== "India"),
      ];

      setCountryList(onlyForeignCountries);
    }
  }, [countries]);

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
      }
      uploadedFilesCount[i] = obj;
    }
    setUploadedFilesCount(uploadedFilesCount);
  };
  // alert(JSON.stringify(uploadedFilesCount));

  const getDocumentIdMandatory = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        obj[
          `${checksDetails[i].required_documents[j].id}`
        ] = `${checksDetails[i].required_documents[j].is_mandatory}`;
      }
      uploadedFilesCount[i] = obj;
    }

    // alert(JSON.stringify(uploadedFilesCount));
    setDocumnetMandatory(uploadedFilesCount);
  };

  // const updateAddressDetails = (dataset, value) => {

  //   let addDetails = _.cloneDeep(address);

  //   addDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
  //     dataset.fieldname
  //   ].field_value = value;

  //   setAddress(addDetails);

  // };

  const [permanentQuestionOptionArray, setPermanentQuestionOptionArray] =
    useState([]);

  //setting address data
  useEffect(() => {
    let optionsFormat = [];

    Object.entries(showPermanentQuesOptions).forEach((element, index) => {
      const [key, value] = element;
      if (value?.check_name !== "Permanent Address Verification") {
        optionsFormat.push({
          value: value.case_check_id,
          label: value.check_name,
        });
      }
    });

    setPermanentQuestionOptionArray(optionsFormat);
  }, [showPermanentQuesOptions]);

  console.log(permanentQuestionOptionArray);

  // getting values to show in dropdowns
  const {
    degreeOptions,
    veridficationCourseNameOptions,
    qualificationOptions,
    modeOfQualificationOptions,
  } = GetMasterData();

  //function to re-rener component
  const reRenderAgain = () => {
    props.reRenderAgain(address);
  };

  const reRenderAgain2 = () => {
    props.reRenderAgain2();
  };

  //cheking if any status is not completed
  const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] =
    useState(0);
  useEffect(() => {
    if (
      typeof address.checksDetails !== "undefined" &&
      address.checksDetails !== null
    ) {
      const completeFlag = Object.entries(address.checksDetails)
      .every(([key, value]) => value.check_status === 2 || value.check_status === 3);

      if(completeFlag){
        setCatchIfAnyStatusIsNotCompleted(0);
      } else {
        setCatchIfAnyStatusIsNotCompleted(1);
        if (checkForAddAddress == false) {
          setCatchIfAnyStatusIsNotCompleted(0);
        }
      }
      Object.entries(address.checksDetails).map(([key, value]) => {
        // if (value.check_status === 2 || value.check_status === 3) {
        //   setCatchIfAnyStatusIsNotCompleted(0);
        // } else {
        //   setCatchIfAnyStatusIsNotCompleted(1);
        // }
        // if (checkForAddAddress == false) {
        //   setCatchIfAnyStatusIsNotCompleted(0);
        // }
        if (value?.fields?.till_date?.field_value) {
          // console.log(`till date check..`,{[`till_date_${value.case_check_id}`]: value.fields.till_date.field_value})
          setNewValidationRecord((prevState) => ({
            ...prevState,
            [`till_date_${value.case_check_id}`]:
              value.fields.till_date.field_value,
          }));
        }
      });
    }
  }, [address, checkForAddAddress]);

  // useEffect(()=> {
  //   if (checkForAddAddress == false) {
  //     setCatchIfAnyStatusIsNotCompleted(0);
  //   }
  // },[checkForAddAddress])

  //for getting the info of fields taht is formatted as per the api format
  const selectHandler = (value) => {
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";

    // alert(JSON.stringify(value))

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    updateDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
  };

  const updateDetails = (dataset, name, value) => {
    // alert(value);
    let details = _.cloneDeep(address);
    if(details.checksDetails[parseInt(dataset)]&&details.checksDetails[parseInt(dataset)].fields){
    details.checksDetails[parseInt(dataset)].fields[name].field_value = value;
    console.log("ee", details);
    setAddress(details);
    }
    // console.log("ee", education);
  };

  const [tillDateChecked, setTillDateChecked] = useState(false);

  const handleCheckboxChange = (value) => {
    // alert(JSON.stringify(value))

    setTillDateChecked(value[0].value);

    //console.log("check"+value[0].value);

    // const { dataset, value } = checkboxValues;

    // if (dataset.fieldname === "till_date") {
    //   let updatedTillDateChecked = _.cloneDeep(tillDateChecked);
    //   const updatedValue =
    //     updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] === true
    //       ? ""
    //       : "checked";

    //   updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] = !updatedTillDateChecked[parseInt(dataset.checkdetailsindex)];
    //   setTillDateChecked(updatedTillDateChecked);

    //    updateAddressDetails(dataset, updatedValue);
    // }

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));

    updateDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
    //this is state is for validation purpose

    // if (dataset.fieldname === "no_ssn") {
    //   let updatedNoSsn = _.cloneDeep(noSsnChecked);
    //   const updatedValue =
    //   updatedNoSsn[parseInt(dataset.checkdetailsindex)] === true
    //       ? ""
    //       : "checked";

    //   updatedNoSsn[parseInt(dataset.checkdetailsindex)] = !updatedNoSsn[parseInt(dataset.checkdetailsindex)];
    //   setNoSsn(updatedNoSsn);
    //   let scotDetails = _.cloneDeep(scotDisclosure);
    //   scotDetails.checksDetails[0].fields['ssn'].is_mandatory = 0;
    //   setScotDisc(scotDetails);
    // }
  };

  const handleSelectChange = (selectValues) => {
    //    const { dataset, value } = selectValues;
    // const ssn = value == 2 ? true : false;
    // let updatedSsn = _.cloneDeep(ssn);
    // updatedSsn = ssn;
    // setIsSsn(updatedSsn);
    //  updateAddressDetails(dataset, value);
  };

  const [showCountry, setShowCountry] = useState(0);

  const selectRadioHandler = (value) => {
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";

    // alert(JSON.stringify(value));

    if (value[0].value === "outside") {
      setShowCountry(1);
    } else {
      setShowCountry(0);
    }

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));

    updateDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
    //this is state is for validation purpose
  };

  //for getting the info of fields taht is formatted as per the api format
  const selectHandlerPin = (value) => {
    let name = "add_" + value[0].caseCheckId;
    let val = document.querySelector(
      'input[name="' + name + '"]:checked'
    )?.value;

    let type = 0;

    if (val == "No") {
      type = 1;
    }

    // alert(JSON.stringify(value))
    if (
      value[0]?.value &&
      value[0]?.err_id &&
      !validatePincodeNew(value[0]?.value, type)
    ) {
      document.getElementById(value[0]?.err_id).innerHTML =
        "Please provide valid Input.";
      return false;
    } else {
      document.getElementById(value[0]?.err_id).innerHTML = "";
    }

    if (val == "Yes") {
      dispatch(getPincode(value));
    }

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose
    updateDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
  };

  //console.log(newValidationRecord);

  const storePincodeData = useSelector((state) => state.pincode);
  const { pincodeData, loading, error, customData } = storePincodeData;

  useEffect(() => {
    if (pincodeData&&typeof pincodeData.data !== "undefined" && pincodeData.data !== null) {
      setNewRecord((prevState) => ({
        ...prevState,
        [3]: pincodeData.data.city_name,
        [2]: pincodeData.data.state_name,
      }));

      //  id={`city_${caseCheckId}` + "_value"}

      if (typeof customData.checkdetailsindex !== "undefined") {
        let details = _.cloneDeep(address);
        details.checksDetails[
          parseInt(customData.checkdetailsindex)
        ].verification_source_id = pincodeData.data.city_id;
        details.checksDetails[parseInt(customData.checkdetailsindex)].fields[
          "city"
        ].field_value = pincodeData?.data.city_name;
        details.checksDetails[parseInt(customData.checkdetailsindex)].fields[
          "location"
        ].field_value = pincodeData?.data.state_name;
        setAddress(details);
        setVerificationSourceId(pincodeData.data.city_id);

        dispatch(deletePinCode());
      }

      //  let value_element = document.getElementById('city_' + customData.caseCheckId + '_value');
      //value_element.value = 100;

      //  updateDetails(customData.checkdetailsindex,"city", pincodeData.data.city_name)
      //  updateDetails(customData.checkdetailsindex,"location", pincodeData.data.state_name)
    }
  }, [pincodeData, storePincodeData, customData]);

  useEffect(() => {
    if (
      typeof pincodeData?.data !== "undefined" &&
      pincodeData?.data !== null
    ) {
      // setNewRecord((prevState) => ({
      //   ...prevState,
      //   [3]: pincodeData.data.city_name,
      //   [2]: pincodeData.data.state_name,
      // }));
      // alert(customData.checkdetailsindex);
      // updateDetails(customData.checkdetailsindex,"city", pincodeData.data.city_name)
      //  updateDetails(customData.checkdetailsindex,"location", pincodeData.data.state_name)
    }
  }, [pincodeData, storePincodeData, customData]);

  //on tab change set data for editing
  const tabChange = (index, caseCheckId) => {
    if (
      typeof address.checksDetails !== "undefined" &&
      address.checksDetails !== null
    ) {
      if (caseCheckId) {
        setActiveTab(index);

        //         var ele = document.getElementsByName("add_2152056");
        // for(var i=0;i<ele.length;i++)
        //     ele[i].checked = false;

        // document.querySelector('input[name="add_2151598"]:checked').checked = false;
        // reRenderAgain();
        navigate(`/case-initiation/check-detail/${reference}/2/${caseCheckId}`);
        //reRenderAgain();
      }

      setTillDateChecked(false);
      //alert("s");

      setVerificationSourceId(
        address.checksDetails[index].verification_source_id
      );

      Object.entries(address.checksDetails[index].fields).map(
        ([key, value]) => {
          setNewRecord((prevState) => ({
            ...prevState,
            [value.id]: value.field_value,
          }));

          //asdsadsad

          if (value.id == 354) {
            setPermanentQuestion(value.field_value == "1" ? "yes" : "no");
          }

          if (value.id == 49) {
            setTillDateChecked(value.field_value == "1" ? true : false);
          }
          if (value?.till_date?.field_value) {
            // console.log(`till date check..2`,{[`till_date_${value?.case_check_id}`]: value?.till_date?.field_value})
            setNewValidationRecord((prevState) => ({
              ...prevState,
              [`till_date_${caseCheckId}`]: value?.till_date?.field_value,
            }));
          }

          if (value.id == 162) {
            if (value.field_value === "outside") {
              setShowCountry(1);
            } else {
              let val = document.querySelector(
                'input[name="' + `add_${caseCheckId}` + '"]:checked'
              )?.value;
              if (val == "No") {
                setShowCountry(1);
              } else {
                setShowCountry(0);
              }
            }
          }

            ////this code is for setting the value of till date checked for current address tab only
          if(value?.check_id == 57 && value?.ibridge_field_id == 49){
            console.log("this code running...")
            const caseCheckID = address.checksDetails[0].case_check_id
            const tillDateAutoEvent = {
              name: `till_date_${caseCheckID}`,
              id:`till_date_${caseCheckID}`,
              fieldId: 49,
              value: true
            }
            // console.log("till check check....",newRecord[
            //   value?.fields?.till_date?.id
            // ])
            handleCheckboxChange([tillDateAutoEvent])
          }
        }
      );
    }
  };

  //select option handler for getting non select handler
  const selectHandler2 = (value) => {
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  //on intial load  set data for editing in first tab
  useEffect(() => {
    if (
      typeof address.checksDetails !== "undefined" &&
      address.checksDetails !== null
    ) {
      console.log("sdsdsd");
      //finding which tab is active
      let activeTab = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          activeTab = tabs[i].dataset.index;
        }
      }
      setNewRecord({});
      setVerificationSourceId();
      if (activeTab == 0) {
        //  alert("d");
        //reRenderAgain()
        setVerificationSourceId(
          address.checksDetails[0].verification_source_id
        );

        Object.entries(address.checksDetails[0].fields).map(([key, value]) => {
          setNewRecord((prevState) => ({
            ...prevState,
            [value.id]: value.field_value,
          }));

          if (value.id == 354) {
            setPermanentQuestion(value.field_value == "1" ? "yes" : "no");
          }

          if (value.id == 49) {
            setTillDateChecked(value.field_value == "1" ? true : false);
          }

          if (value.id == 162) {
            // alert(value.field_value);

            if (value.field_value === "outside") {
              setShowCountry(1);
            } else {
              setShowCountry(0);
            }
          }

            ////this code is for setting the value of till date checked for current address tab only
          if(value?.check_id == 57 && value?.ibridge_field_id == 49){
            console.log("this code running...")
            const caseCheckID = address.checksDetails[0].case_check_id
            const tillDateAutoEvent = {
              name: `till_date_${caseCheckID}`,
              id:`till_date_${caseCheckID}`,
              fieldId: 49,
              value: true
            }
            // console.log("till check check....",newRecord[
            //   value?.fields?.till_date?.id
            // ])
            handleCheckboxChange([tillDateAutoEvent])
          }

          // setVerificationSourceId(value.verification_source_id);
        });
      }
    }
  }, [address, active]);

  //on intial load  set data for editing in first tab
  useEffect(() => {
    if (
      typeof address.checksDetails !== "undefined" &&
      address.checksDetails !== null
    ) {
      //here find index of the tab with caseCheckId
      //finding which tab is active
      let foundIndex = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          const dataCaseCh = tabs[i].dataset.casecheckid;
          if (dataCaseCh == active) {
            foundIndex = tabs[i].dataset.index;
          }
        }
      }
      // alert(foundIndex);
      if (active !== null && active !== undefined && foundIndex !== null) {
        tabChange(foundIndex, active);
      }
    }
  }, [address, active]);

  //form validation logic
  const formValidation = (caseCheckId, activeTabIndex, check_id) => {
    const errors = {};
    let isError = false;

    // resetting all errors first
    var cols = document.getElementsByClassName("err text-danger");
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = "";
    }

    let activeTab = activeTabIndex - 1;
    let case_check_id = address.checksDetails[activeTab].case_check_id;

    let applyValidation = 1;

    if (check_id == 1) {
      let value_element = document.getElementsByName(
        "isAddressQuestion_" + case_check_id + "_value"
      )[0]?.value;

      if (value_element == "") {
        let field_is_same =
          address.checksDetails[activeTab].fields.same_address;

        //checking if filed coming from api is mandatory
        //if (field_mapped.is_mandatory == 1) {
        if (1) {
          //getting field id from api data
          let fieldId = field_is_same.id;
          //identifying which err id element needs to be populated with error
          let elementErrorId = "err_" + case_check_id + "_" + fieldId;
          //let elementName = 'mappedQuestion_' + case_check_id;

          let value_element = document.getElementsByName(
            "isAddressQuestion_" + case_check_id + "_value"
          )[0].value;

          if (
            value_element === undefined ||
            value_element === null ||
            value_element === "" ||
            value_element.trim() == ""
          ) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
        }
      }
    }

    if (check_id == 1 && showPermanentQues == 1) {
      let value_element = document.getElementsByName(
        "isAddressQuestion_" + case_check_id + "_value"
      )[0]?.value;

      if (value_element == "yes") {
        let field_mapped =
          address.checksDetails[activeTab].fields.mapped_address;

        //checking if filed coming from api is mandatory
        //if (field_mapped.is_mandatory == 1) {
        if (1) {
          //getting field id from api data
          let fieldId = field_mapped.id;
          //identifying which err id element needs to be populated with error
          let elementErrorId = "err_" + case_check_id + "_" + fieldId;
          //let elementName = 'mappedQuestion_' + case_check_id;

          let value_element = document.getElementsByName(
            "mappedQuestion_" + case_check_id + "_value"
          )[0].value;

          if (
            value_element === undefined ||
            value_element === null ||
            value_element === "" ||
            value_element.trim() == ""
          ) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
        }

        applyValidation = 0;
      }
    }

    //alert(applyValidation)

    if (applyValidation) {
      let field_flat = address.checksDetails[activeTab].fields.address;
      //checking if filed coming from api is mandatory
      if (field_flat.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_flat.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementsByName(
          "address_" + case_check_id
        )[0]?.value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }

      let field_colony_street =
        address.checksDetails[activeTab].fields.colony_street;
      //checking if filed coming from api is mandatory
      if (field_colony_street.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_colony_street.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementsByName(
          "street_" + case_check_id
        )[0]?.value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }
      if(!newValidationRecord[`till_date_${caseCheckId}`] 
      && address?.checksDetails[activeTab]?.IB_CHECK_NAME?.toUpperCase()?.includes("CURRENT")
      ) {
        let till_date_field = address?.checksDetails[activeTab]?.fields?.till_date;
          //identifying which err id element needs to be populated with error
          if(till_date_field?.is_mandatory == 1) {
            let elementErrorId = "err_" + case_check_id + "_" + till_date_field?.ibridge_field_id;
            document.getElementById(elementErrorId).innerHTML =
                  "This field is required.";
            isError = true;
          }
      } else if (!newValidationRecord[`till_date_${caseCheckId}`]) {
        let field_residing_from =
          address.checksDetails[activeTab].fields.residing_from;
        //checking if filed coming from api is mandatory
        if (field_residing_from?.is_mandatory == 1) {
          //getting field id from api data
          let fieldId = field_residing_from?.id;
          //identifying which err id element needs to be populated with error
          let elementErrorId = "err_" + case_check_id + "_" + fieldId;

          //   let elementName = 'address_' + case_check_id;
          let value_element = document.getElementById(
            "residingTo_" + case_check_id
          )?.value;

          if (
            value_element === undefined ||
            value_element === null ||
            value_element === "" ||
            value_element.trim() == ""
          ) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
        }
      }

      //alert(JSON.stringify(tillDateChecked));
      // if(!tillDateChecked){

      let field_residing_since =
        address.checksDetails[activeTab].fields.residing_since;
      //checking if filed coming from api is mandatory
      if (field_residing_since.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_residing_since.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementById(
          "residingFrom_" + case_check_id
        )?.value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }

      let field_pin_code = address.checksDetails[activeTab].fields.pin_code;
      //checking if filed coming from api is mandatory
      if (field_pin_code.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_pin_code.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementsByName(
          "pin_" + case_check_id
        )[0]?.value;

        let type = 0;

        let radio = document.querySelector(
          'input[name="add_' + case_check_id + '"]:checked'
        );
        // alert(radio);
        if (radio !== null) {
          if (radio.value == "No") {
            type = 1;
          }
        }

        //   alert(type);

        // if (val == "No") {

        //   type = 1;

        // }

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        } else if (value_element && !validatePincodeNew(value_element, type)) {
          document.getElementById(elementErrorId).innerHTML =
            "Please provide valid Input.";
          isError = true;
        }
      }

      /*
          let field_state= address.checksDetails[activeTab].fields.state;
          //checking if filed coming from api is mandatory
          if (field_state.is_mandatory == 1) {
            //getting field id from api data
            let fieldId = field_state.id;
            //identifying which err id element needs to be populated with error
            let elementErrorId = 'err_' + case_check_id + '_' + fieldId;

         //   let elementName = 'address_' + case_check_id;

            let value_element = document.getElementsByName('state_' + case_check_id)[0].value;

            if (value_element === undefined || value_element === null || value_element === "") {
              document.getElementById(elementErrorId).innerHTML = "This field is required.";
              isError = true;
            }

          }

      */

      let field_city = address.checksDetails[activeTab].fields.city;
      //checking if filed coming from api is mandatory
      if (field_city.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_city.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementsByName(
          "city_" + case_check_id
        )[0]?.value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }

      let field_state = address.checksDetails[activeTab].fields.location;
      //checking if filed coming from api is mandatory
      if (field_state.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_state.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementsByName(
          "state_" + case_check_id
        )[0]?.value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }

      let field_police_station =
        address.checksDetails[activeTab].fields.police_station;
      //checking if filed coming from api is mandatory
      if (field_police_station?.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_police_station?.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementsByName(
          "policeStation_" + case_check_id
        )[0]?.value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }

      let field_landmark_additional_address =
        address.checksDetails[activeTab].fields.landmark_additional_address;
      //checking if filed coming from api is mandatory
      if (field_landmark_additional_address.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = field_landmark_additional_address.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let value_element = document.getElementsByName(
          "landMark_" + case_check_id
        )[0]?.value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === "" ||
          value_element.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }

      let radio = document.querySelector(
        'input[name="add_' + case_check_id + '"]:checked'
      );
      // alert(radio);
      if (radio !== null) {
        if (radio.value == "No") {
          let field_country = address.checksDetails[activeTab].fields.country;
          //checking if filed coming from api is mandatory
          if (field_country.is_mandatory == 1) {
            //getting field id from api data
            let fieldId = field_country.id;
            //identifying which err id element needs to be populated with error
            let elementErrorId = "err_" + case_check_id + "_" + fieldId;

            //   let elementName = 'address_' + case_check_id;

            let value_element = document.getElementsByName(
              "country_" + case_check_id
            )[0]?.value;

            if (
              value_element === undefined ||
              value_element === null ||
              value_element === "" ||
              value_element.trim() == ""
            ) {
              document.getElementById(elementErrorId).innerHTML =
                "This field is required.";
              isError = true;
            }
          }
        }
      }

      let address_belongs_to =
        address.checksDetails[activeTab].fields.address_belongs_to;
      //checking if filed coming from api is mandatory
      if (address_belongs_to.is_mandatory == 1) {
        //getting field id from api data
        let fieldId = address_belongs_to.id;
        //identifying which err id element needs to be populated with error
        let elementErrorId = "err_" + case_check_id + "_" + fieldId;

        //   let elementName = 'address_' + case_check_id;

        let yes_element = document.getElementsByName("add_" + case_check_id)[0]
          ?.checked;
        let no_element = document.getElementsByName("add_" + case_check_id)[1]
          ?.checked;

        if (!(yes_element || no_element)) {
          console.log("reaching here");
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }

      console.log(errorMessage);

      address.checksDetails[activeTab].required_documents &&
        Object.entries(address.checksDetails[activeTab].required_documents).map(
          ([key, value]) => {
            if (key == 0) {
              let docCount = document.getElementById(
                "document_" + value.id + "_count_" + case_check_id
              ).value;
              let is_man = document.getElementById(
                "document_" + value.id + "_count_" + case_check_id
              ).dataset.mandatory;

              if (docCount <= 0 && is_man == 1) {
                let elementErrorId =
                  "err_document_" + value.id + "_count_" + case_check_id;

                document.getElementById(elementErrorId).innerHTML =
                  "This field is required.";
                isError = true;
              }
              if (errorMessage == "true") {
                let elementErrorId =
                  "err_document_" + value.id + "_count_" + case_check_id;
                document.getElementById(elementErrorId).innerHTML =
                  "File format not valid.";
                isError = true;
              }
            }
          }
        );

        const addressConfirmation = isAddressConfirm[case_check_id];
        if (!addressConfirmation) {
          document.getElementById(
            `error_confirm_address_checkbox_${case_check_id}`
          ).innerHTML = "Please Confirm Your Address.";
          // toast.error("Please confirm address before saving..", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
          // document?.getElementById(`confirm_address_checkbox`)?.scrollIntoView();
          isError = true;
        }

      // if (check_id == 57) {

      //   let docCount_366 = document.getElementById("document_366_count_" + case_check_id).value;
      //   const is_man_366 = document.getElementById("document_366_count_" + case_check_id).dataset.mandatory;

      //   if (docCount_366 <= 0 && is_man_366) {
      //     let elementErrorId = 'err_document_366_count_' + case_check_id;

      //     document.getElementById(elementErrorId).innerHTML = "This field is required.";
      //     isError = true;
      //   }

      //   if (errorMessage == "true") {
      //     let elementErrorId = 'err_document_366_count_' + case_check_id;
      //     document.getElementById(elementErrorId).innerHTML = "File format not valid.";
      //     isError = true;
      //   }

      // } else {
      //   let docCount_387 = document.getElementById("document_387_count_" + case_check_id).value;
      //   const is_man_387 = document.getElementById("document_387_count_" + case_check_id).dataset.mandatory;

      //   if (docCount_387 <= 0 && is_man_387) {
      //     let elementErrorId = 'err_document_387_count_' + case_check_id;

      //     document.getElementById(elementErrorId).innerHTML = "This field is required.";
      //     isError = true;
      //   }
      //   if (errorMessage == "true") {
      //     let elementErrorId = 'err_document_387_count_' + case_check_id;
      //     document.getElementById(elementErrorId).innerHTML = "File format not valid.";
      //     isError = true;
      //   }

      // }
    }

    return isError;
  };

  const storeLandingData = useSelector((state) => state.landingPage);
  const {
    loadingData,
    loading: landingloading,
    error: landingError,
  } = storeLandingData;

  //form save handler
  const saveHandler = (event, caseCheckId, activetabIndex, check_id) => {
    event.preventDefault();
    // const formData2 = {};
    // formData2.formVal1 = formVal.formVal1;
    console.log(caseCheckId);
    let err = formValidation(caseCheckId, activetabIndex, check_id);
    // const err = false;
    // const isValidationPassed = Object.keys(err).length === 0;
    console.log(caseCheckId);
    // if(check_id === 1 && permanentQuestion === ''){
    //   err = true
    //   toast.dismiss();

    //   toast.error("Something went wrong", {
    //   position: "top-right",
    //   autoClose: 2000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
    // }
    if (err === true) {
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      let verificationSource = document.getElementById(
        "city_" + caseCheckId + "_value"
      ).value;

      // let verificationSource = document.getElementById("cis_" + caseCheckId + "_value").value;
      // let verificationSourceText = document.getElementById("cis_" + caseCheckId).value;

      // const additonalData = {
      //   // "verificationCourse": "4",
      //   "verificationName": verificationSourceText,
      //   "verificationSource": parseInt(verificationSource),
      //   "verificationSourceText": verificationSourceText,
      //   // "otherVerificationSource": ""
      // }

      const additonalData = {
        // "verificationCourse": "4",
        thischeckid: check_id,
        cityverificationsrc: parseInt(verificationSource),
        stateverificationsrc: "",
        // "otherVerificationSource": ""
      };

      // if (newRecord[162] == 'india') {

      // delete newRecord[209];

      // }

      if (newRecord[354] && newRecord[354] == 1) {
        let mappedAddress = document.getElementById(
          "mappedQuestion_" + caseCheckId + "_value"
        ).value;
        additonalData.same_permanent_address = 1;
        additonalData.mapped_address = mappedAddress;
      }

      //  alert(newRecord[354]);

      // "same_permanent_address": 1,
      //    "mapped_address":

      const recordData = {};
      recordData.case_check_id = caseCheckId;

      console.log("as" + JSON.stringify(newRecord));

      const obj = {
        group: "address",
        // "13": "12\/2014",
        // "69": "3",
        // "11": "3333",
        // "12": "",
        // "138": "test",
        // "52": "1",
        ...newRecord,
        ...additonalData,
      };

      // recordData.check_data = { [caseCheckId]: { "group": "address", ...newRecord, ...additonalData } };
      recordData.check_data = { [caseCheckId]: obj };
      //console.log(recordData);

      //  dispatch(saveAddress(recordData));

      // const { Data, loading: landingloading, error: landingError } = storeLandingData;

      // let groupIds = [2]
      // let filteredArray = Data.data.totalGroupsOfChecks.filter(function(itm){
      // return groupIds.indexOf(itm.group_id) > -1;
      // });

      // let tabStatus = filteredArray[0].completed;

      //checking if checks are not completed than only go inside the condition

      // if(tabStatus != '1')
      // {
      let last = Object.keys(address.checksDetails)[
        Object.keys(address.checksDetails).length - 1
      ];

      // debugger;

      if (activeTab == last && isAddressValidation == 1) {
        dispatch(validateAddress(recordData));
        setLastRecordData({...recordData});
      } else {
        //  debugger;

        dispatch(saveAddress(recordData));
        dispatch(deleteValidateAddress);
      }

      // }

      /*


      const { Data, loading: landingloading, error: landingError } = storeLandingData;

      console.log("total", Data.data.totalGroupsOfChecks);

      let groupIds = [2]
      let filteredArray = Data.data.totalGroupsOfChecks.filter(function(itm){
      return groupIds.indexOf(itm.group_id) > -1;
      });

     // console.log("fil",filteredArray);

      let tabStatus = filteredArray[0].completed;

      //console.log("tab",tabStatus);

    //  alert(tabStatus);

      if(tabStatus == 'false'){

        //getting last tab info

        let last = Object.keys(address.checksDetails)[Object.keys(address.checksDetails).length-1];
        console.log("last", last)

        // alert("ac", activeTab)
        // alert("ac", activeTab)

        if(activeTab == last){
          alert("1")
        //  dispatch(validateAddress(recordData));
        }else{
          alert("2")
        //  dispatch(saveAddress(recordData));
        }

      }else{

        alert("3")
      //  dispatch(validateAddress(recordData));

      }

      //dispatch(validateAddress(recordData));

      // dispatch(saveAddress(recordData));

      */
    }
  };

  //setting loader while saving
  const storeAddressValidation = useSelector(
    (state) => state.addressValidation
  );
  const {
    addressValidationData,
    record,
    loading: validationLoading,
    error: validationError,
  } = storeAddressValidation;
  useEffect(() => {
    if (
      typeof validationLoading !== "undefined" &&
      validationLoading !== null
    ) {
      if (validationLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);

        //alert(JSON.stringify(addressValidationData))

        if (addressValidationData.valid == 0) {
          //   alert(JSON.stringify(record))
          setShowValidationPopup(true);
          setValidationPopupTitle(addressValidationData.msg);
          setValidationPopupHeading(addressValidationData.etype);
          if (addressValidationData?.add_address) {
            const condition = addressValidationData.add_address == 1 ? false : true;
            setCheckForAddAddress(condition);
          } else {
            setLastRecordData(null);
            setCheckForAddAddress(true);
          }
        } else if (addressValidationData.valid == 1) {
          setCheckForAddAddress(true);
          setLastRecordData(null);
          dispatch(saveAddress(record));
          dispatch(deleteValidateAddress());
          setShowValidationPopup(false);
        }

        // dispatch(getData());

        // reRenderAgain2();
      }
    }
  }, [validationLoading, addressValidationData]);

  //setting loader while saving
  const storeAddressSave = useSelector((state) => state.addressSave);
  const {
    addressSaveData,
    loading: saveLoading,
    error: saveError,
  } = storeAddressSave;
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //reRenderAgain2();
      }
    }
  }, [saveLoading]);

  //redirecting after saving
  useEffect(() => {
    if (
      typeof addressSaveData?.reference_number !== "undefined" &&
      addressSaveData?.reference_number !== null
    ) {
      dispatch(getData());
      props.reSetData();
      reRenderAgain2();

      // const hasNextCheck = addressSaveData.nextCheck != '' ? true : false;
      // // alert(hasNextCheck);
      // if (!hasNextCheck) {
      //   navigate(
      //     `/case-initiation/check-detail/${reference}/${addressSaveData.group.group_id}`
      //   );
      //   dispatch(deleteSaveAddress());
      // } else {

      //   navigate(
      //     `/case-initiation/check-detail/${reference}/${addressSaveData.group}/${addressSaveData.nextCheck}`
      //   );
      //   dispatch(deleteSaveAddress());
      //   window.scrollTo(0, 0)

      const group = addressSaveData.group ? addressSaveData.group.group_id : "";
      const hasNextCheck = addressSaveData.nextCheck != "" ? true : false;
      const reference = addressSaveData.reference_number;
      if (!hasNextCheck) {
        if (
          group == "profile_preview" ||
          addressSaveData.group == "profile_preview"
        ) {
          navigate(`/case-initiation/profile-preview/${reference}`);
          dispatch(deleteSaveAddress());
        } else if (typeof group != "undefined" && group != "") {
          // console.log("navigation here 1479...")
          navigate(`/case-initiation/check-detail/${reference}/${group}`);
          dispatch(deleteSaveAddress());
        }
      } else {
        // console.log("navigation here 1484...")
        navigate(
          `/case-initiation/check-detail/${reference}/2/${addressSaveData.nextCheck}`
        );
        dispatch(deleteSaveAddress());
        window.scrollTo(0, 0);
      }
    }
  }, [addressSaveData, storeAddressSave]);

  // // add address click handler
  // const handleAddressAddClick = (e) => {
  //   e.preventDefault();
  //   setNewRecord({});
  //   dispatch(addAddress());
  //   reRenderAgain();
  // };

  // const addAddressStoreData = useSelector((state) => state.addressAdd);
  // const { addressAddData, loading: addLoad, error: addError } = addAddressStoreData;
  // const [addressAddedState, setAddressAddedState] = useState();

  // //after add handler modify existing main state
  // useEffect(() => {
  //   if (
  //     typeof addressAddData.data !== "undefined" &&
  //     addressAddData.data !== null
  //   ) {
  //     // const newAddress = { ...address };
  //     // newAddress['checksDetails'][addressAddData.data.checksCount - 1] = addressAddData.data.checksDetails[0];
  //     // setAddress(newAddress);
  //     // setAddressAddedState(1);

  //     navigate(
  //       `/case-initiation/check-detail/${reference}/2/${addressAddData.data.checksDetails[0].case_check_id}`
  //     );

  //     reRenderAgain2();

  //   }

  // }, [addressAddData]);

  //on add handler initiate loader
  // useEffect(() => {
  //   if (typeof addLoad !== "undefined" && addLoad !== null) {
  //     if (addLoad === true) {
  //       setIsLoading(true);
  //     } else {
  //       setIsLoading(false);
  //       reRenderAgain2();
  //     }

  //   }
  // }, [addressAddData]);

  const closeRemovePopup = () => {
    setShowRemovePopup(false);
  };

  const proceedRemove = () => {
    if (checkIdToBeRemoved) {
      dispatch(removeAddress(checkIdToBeRemoved,deleteCheckCallback));
      reRenderAgain();
      setCheckIdToBeRemoved(null);
      setShowRemovePopup(false);
    }
  };

  const closeValidationPopup = () => {
    setShowValidationPopup(false);
    dispatch(deleteValidateAddress());
  };

  const proceedValidation = () => {
    setShowValidationPopup(false);
    dispatch(deleteValidateAddress());
  };

  //execute call api on remove hanler
  const handleAddressRemoveClick = (e, caseCheckId) => {
    // setShowModal(1);
    //  e.preventDefault();
    e.preventDefault();
    // dispatch(removeAddress(caseCheckId));
    // window.location.reload(false);
    //  reRenderAgain();

    setCheckIdToBeRemoved(caseCheckId);
    setShowRemovePopup(true);
  };

  //setting loader while saving
  const storeAddressRemove = useSelector((state) => state.addressRemove);
  const {
    addressRemoveData,
    loading: removeLoading,
    error: removeError,
  } = storeAddressRemove;
  useEffect(() => {
    if (typeof removeLoading !== "undefined" && removeLoading !== null) {
      if (removeLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        // reRenderAgain();
      }
    }
  }, [removeLoading]);

  //after add handler remove active from all tabs and append it on last
  useEffect(() => {
    if (
      typeof addressRemoveData.case_check_id !== "undefined" &&
      addressRemoveData.case_check_id !== null
    ) {
      dispatch(getData());
      props.reSetData();
      // console.log("navigation here 1600...")
      navigate(`/case-initiation/check-detail/${reference}/2`);
      if(activeTab > 0){
        setActiveTab(prevState => prevState - 1);
      }

      reRenderAgain2();
    }
  }, [addressRemoveData, storeAddressRemove]);

  const options = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const [permanentQuestion, setPermanentQuestion] = useState(null);

  const selectPermanentQuestionHandler = (value) => {
    setPermanentQuestion(value[0].value);
    console.log(value[0].value);

    let mainForm = document.getElementById("main-form-" + value[0].caseCheckId);
    let quesAddress = document.getElementById(
      "ques-address-" + value[0].caseCheckId
    );

    if (value[0].value == "no") {
      mainForm.classList.add("show");
      mainForm.classList.remove("hidden");

      quesAddress.classList.add("hidden");
      quesAddress.classList.remove("show");
    } else if (value[0].value == "yes") {
      mainForm.classList.add("hidden");
      mainForm.classList.remove("show");

      // quesAddress.classList.add("show");
      // quesAddress.classList.remove("hidden");
      //    alert(value[0].value);
    }

    // var tabs = document.getElementsByClassName('nav-link tab');
    //  for (let i = 0; i < tabs.length; i++) {
    //   // if(tabs[i].classList.contains("active")){
    //   //   activeTab = tabs[i].dataset.index;
    //   // }
    //   tabs[i].classList.remove("active");
    // }
    // let tabLength = parseInt(tabs.length);
    // tabs[tabLength - 1].classList.add("active");

    // let name = "add_" + value[0].caseCheckId;

    // let val =  document.querySelector('input[name="'+ name +'"]:checked').value;

    //  if(val == "Yes"){
    //  dispatch(getPincode(value));
    //  }

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value == "yes" ? "1" : "",
    }));
    //  this is state is for the purpose of storing data to the api

    //  this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value == "yes" ? "1" : "",
    }));

    updateDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value == "yes" ? "1" : ""
    );

    // alert(JSON.stringify(newRecord));
    //this is state is for validation purpose
  };

  // const [permanentQuestion1, setPermanentQuestion1] = useState();

  // useEffect(() => {

  //   if(showPermanentQues == 1){

  //     setPermanentQuestion1("yes");

  //   }else{
  //     setPermanentQuestion1("no");
  //   }

  // }, [showPermanentQues]);

  const errorCheck = (data) => {
    console.log(data);
    setErrorMessage(data);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  return (
    <>
      {/* {(loading || loadRS) && <Loader />} */}

      {isLoading && <Loader />}

      {showAddPopup == true && catchIfAnyStatusIsNotCompleted != 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Address"
          description="Are you sure you want to add another Address?"
          proceedHandler={proceedAdd}
          isAdd={true}
          checkStatus={catchIfAnyStatusIsNotCompleted}
        />
      )}
      {showAddPopup == true && catchIfAnyStatusIsNotCompleted == 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Address"
          description="Save the existing address, before adding a new one"
          proceedHandler={proceedAdd}
          isAdd={false}
          checkStatus={catchIfAnyStatusIsNotCompleted}
        />
      )}

      {showRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemovePopup}
          title="Remove Address"
          description="Are you sure you want to remove this address?"
          proceedHandler={proceedRemove}
          isAdd={false}
        />
      )}

      {showValidationPopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeValidationPopup}
          title={validationPopupHeading}
          description={validationPopupTitle}
          proceedHandler={proceedValidation}
          isAdd={false}
        />
      )}

      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {address.checksDetails &&
            Object.entries(address.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;
              const name = value.IB_CHECK_NAME;

              let activeClass = "";
              if (typeof active !== "undefined") {
                console.log(active + index);
                if (active == caseCheckId) {
                  activeClass = "show active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }

              let completeClass = "";

              if (caseCheckStatus === 2 || caseCheckStatus === 3) {
                completeClass = "completed";
              }

              return (
                <li className={`nav-item ${completeClass}`} key={key}>
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`address-tab-${index}`}
                    data-toggle="tab"
                    href={`#address-${index}`}
                    role="tab"
                    aria-controls={`address-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-caseCheckId={caseCheckId}
                    onClick={() => tabChange(key, caseCheckId)}
                  >
                    {(caseCheckStatus === 2 || caseCheckStatus === 3) && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    {name}
                  </a>
                </li>
              );
            })}

          {/* <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="current-address-tab"
                        data-toggle="tab"
                        href="#current-address"
                        role="tab"
                        aria-controls="current-address"
                        aria-selected="true"
                      >
                        Current Address
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="permanent-address-tab"
                        data-toggle="tab"
                        href="#permanent-address"
                        role="tab"
                        aria-controls="permanent-address"
                        aria-selected="false"
                      >
                        Permanent Address
                      </a>
                    </li> */}
        </ul>

        {/* {catchIfAnyStatusIsNotCompleted === 0 &&
          <button className="btn btn-primary add-btn" style={{ minWidth: '155' + 'px' }} onClick={(e) => handleAddressAddClick(e)}>+ Add Address</button>
        } */}
      </div>
      <hr />

      <div className="tab-content" id="myTabContent">
        {address.checksDetails &&
          Object.entries(address.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;
            const caseCheckId = value.case_check_id;
            const checkId = value.check_id;
            const isDisabled=address?.clientId==387715?true:false;
            //mapping needs to be checked need fields array here
            const cisSlug = "verificationName_" + caseCheckId;
            // console.log(value.fields[cisSlug]);

            let activeClass = "";
            if (typeof active !== "undefined") {
              console.log(active + index);
              if (active == caseCheckId) {
                activeClass = "show active";
              }
            } else if (index === 1) {
              activeClass = "show active";
            }

            //////

            let doc346Count = 0;

            if (value.uploaded_documents != null) {
              const doc346 = value.uploaded_documents.filter(
                (value) => value.document_id === 346
              );

              doc346Count = doc346.length;
            }

            // let verficationSourceName = value.verification_source_name;
            // let verficationSourceid = value.verification_source_id;

            /////////////////////////////

            let classNameOnMain = "";

            if (checkId == 1) {
              // if(p){
              if (value.fields.same_address.field_value == "") {
                // alert(value.fields.same_address.field_value);
                classNameOnMain = "show";
              } else {
                classNameOnMain = "hidden";
              }
              // }

              //        if(permanentQuestion == 'yes'){
              if (value.fields.same_address.field_value == "1") {
                classNameOnMain = "hidden";
              } else {
                classNameOnMain = "show";
              }

              // }

              // }else if(permanentQuestion == 'yes' && value.fields.same_address.field_value != 1){
              //   classNameOnMain = "hidden";
              // }

              // (typeof value.fields.same_address != 'undefined' && value.fields.same_address.field_value != 1)
            }

            /////////////////////////////////////

            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`address-${index}`}
                role="tabpanel"
                aria-labelledby={`address-tab-${index}`}
                key={key}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span>{/* Address-{`${index}`} */}</span>
                  {edu.is_custom_address == 1 &&
                    Object.entries(address.checksDetails).length > 1 && //only one check
                    checkId != 1 && // permanent address
                    checkId != 57 && ( // current address
                      <button
                        class="btn btn-outline-secondary mt-3 mr-2"
                        onClick={(e) =>
                          handleAddressRemoveClick(e, caseCheckId)
                        }
                      >
                        <i class="far fa-trash-alt mr-2"></i>
                        Remove
                      </button>
                    )}
                </div>

                {checkId == 1 && showPermanentQues == 1 ? (
                  <>
                    <div className="row">
                      <AddSimpleSelect
                        type={
                          1
                        } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                        name={`isAddressQuestion_${caseCheckId}`}
                        id={`isAddressQuestion_${caseCheckId}`}
                        fieldId={value.fields.same_address.id}
                        // placeholder="Is address Same"
                        placeholder = "Is this address same as Previous address?"
                        // autoComplete="off"
                        options={options}
                        // attachOther={true}
                        // verificationType={6}
                        selectOption={selectPermanentQuestionHandler}
                        isRequired={1}
                        errId={`err_${caseCheckId}_${value.fields.same_address.id}`}
                        caseCheckId={caseCheckId}
                        selectedLabel={
                          permanentQuestion === ""
                            ? permanentQuestion
                            : value.fields.same_address.field_value == 1
                            ? "Yes"
                            : "No"
                        }
                        value={
                          permanentQuestion === ""
                            ? permanentQuestion
                            : value.fields.same_address.field_value == 1
                            ? "yes"
                            : "no"
                        }
                        hiddenValue={
                          permanentQuestion === ""
                            ? permanentQuestion
                            : value.fields.same_address.field_value == 1
                            ? "yes"
                            : "no"
                        }
                        // Checking on empty option to avoid save
                        checkDetailsIndex={key}
                        fieldName="same_address"
                        // returnType="name"
                      />
                      <p className="err text-danger">{formError.formVal1}</p>
                    </div>
                  </>
                ) : (
                  <></>
                )}

                {(() => {
                  if (checkId == 1) {
                    if (
                      value.fields.same_address.field_value == 1 &&
                      permanentQuestion == "yes"
                    ) {
                      return (
                        <>
                          {/* {value.fields.same_address.field_value} */}
                          <div
                            className="row"
                            id={`ques-address-${caseCheckId}`}
                          >
                            <AddSimpleSelect
                              type={
                                1
                              } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                              name={`mappedQuestion_${caseCheckId}`}
                              id={`mappedQuestion_${caseCheckId}`}
                              fieldId={value.fields.mapped_address.id}
                              placeholder="Select Address"
                              // autoComplete="off"
                              options={permanentQuestionOptionArray}
                              // attachOther={true}
                              // verificationType={6}
                              selectOption={selectHandler}
                              //   isRequired={value.fields.mapped_address.is_mandatory}
                              isRequired={1}
                              errId={`err_${caseCheckId}_${value.fields.mapped_address.id}`}
                              caseCheckId={caseCheckId}
                              // value={value.fields.mapped_address.field_value}
                              // hiddenValue={
                              //   value.fields.mapped_address.field_value
                              // }
                              value={value.fields.mapped_address.field_value || value.fields.mapped_address.field_value == '' ? permanentQuestionOptionArray?.[0]?.value : ''}
                              hiddenValue={
                                value.fields.mapped_address.field_value || value.fields.mapped_address.field_value == '' ? permanentQuestionOptionArray?.[0]?.value : ''
                              }
                              // value={permanentQuestionOptionArray.filter(obj => obj.value == value.fields.mapped_address.field_value)}
                              // returnType="name"
                              checkDetailsIndex={key}
                              fieldName="mapped_address"
                            />
                            <p className="err text-danger">
                              {formError.formVal1}
                            </p>
                          </div>
                        </>
                      );
                    }
                    // else {
                    //   return (

                    //   );
                  }
                })()}

                <>
                  <div
                    className={`main-form ${classNameOnMain}`}
                    id={`main-form-${caseCheckId}`}
                  >
                    <div className="row">
                      {value.fields.address_belongs_to ? (
                        <ABRadioAddress
                          caseCheckId={caseCheckId}
                          name={`inIndia_${caseCheckId}`}
                          id={`inIndia_${caseCheckId}`}
                          inputText={selectRadioHandler}
                          fieldId={value.fields.address_belongs_to.id}
                          value={
                            value.fields.address_belongs_to.field_value
                              ? value.fields.address_belongs_to.field_value
                              : "india"
                          }
                          isRequired={
                            value?.fields?.address_belongs_to?.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value?.fields?.address_belongs_to?.id}`}
                          checkDetailsIndex={key}
                          fieldName="address_belongs_to"
                          isDisabled={isDisabled}
                        />
                      ) : (
                        <></>
                      )}
                    </div>

                    <br />

                    <div className="row">
                      {value.fields.address ? (
                        <ABTextEdu
                          name={`address_${caseCheckId}`}
                          id={`address_${caseCheckId}`}
                          fieldId={value.fields.address.id}
                          label="Flat/House No/Floor/Building"
                          isRequired={1}
                          errId={`err_${caseCheckId}_${value.fields.address.id}`}
                          inputText={selectHandler}
                          value={newRecord[value.fields.address.id]}
                          // value={newRecord[value.fields.college_location.id]}
                          checkDetailsIndex={key}
                          fieldName="address"
                        />
                      ) : (
                        <></>
                      )}

                      {value.fields.colony_street ? (
                        <ABTextEdu
                          name={`street_${caseCheckId}`}
                          id={`street_${caseCheckId}`}
                          fieldId={value.fields.colony_street.id}
                          label="Colony/Street/Locality"
                          isRequired={1}
                          errId={`err_${caseCheckId}_${value.fields.colony_street.id}`}
                          inputText={selectHandler}
                          value={newRecord[value.fields.colony_street.id]}
                          checkDetailsIndex={key}
                          fieldName="colony_street"
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="row">
                      {value.fields.residing_since ? (
                        <ABDateAddress
                          // paramStartDate={
                          //   new Date()
                          // }
                          // paramStartDate={null}
                          paramStartDate={
                            value.fields.residing_since.field_value
                          }
                          placeholder="Residing From"
                          name={`residingFrom_${caseCheckId}`}
                          id={`residingFrom_${caseCheckId}`}
                          fieldId={value.fields.residing_since.id}
                          isRequired={value.fields.residing_since.is_mandatory}
                          errId={`err_${caseCheckId}_${value.fields.residing_since.id}`}
                          intialStatus={0}
                          dateSelect={selectHandler}
                          minimumDate={localStorage.getItem('dob') || ""}
                          maximumDate={
                            value?.fields?.residing_from?.field_value || ""
                          }
                          // maximumDate={newRecord[value.fields.residing_from.id]}
                          checkDetailsIndex={key}
                          fieldName="residing_since"
                          // dateSelect={(date) => {
                          //processConfirmationDateSelectHandler(date);
                          //     console.log(date)
                          //  }}
                        />
                      ) : (
                        <></>
                      )}

                      {value.fields.residing_from &&
                      tillDateChecked === false ? (
                        <ABDateAddress
                          // paramStartDate={
                          //   new Date()
                          // }
                          paramStartDate={
                            value.fields.residing_from.field_value
                          }
                          placeholder="Residing To"
                          name={`residingTo_${caseCheckId}`}
                          id={`residingTo_${caseCheckId}`}
                          fieldId={value.fields.residing_from.id}
                          isRequired={
                            !newValidationRecord[`till_date_${caseCheckId}`] &&
                            value?.fields?.residing_from?.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value?.fields?.residing_from?.id}`}
                          intialStatus={0}
                          isDisabled={
                            !tillDateChecked && tillDateChecked === true //not currently in use
                              ? true
                              : false
                          }
                          dateSelect={selectHandler}
                          minimumDate={value.fields.residing_since.field_value}
                          //minimumDate={newRecord[value.fields.residing_since.id]}
                          checkDetailsIndex={key}
                          fieldName="residing_from"

                          // dateSelect={(date) => {
                          //processConfirmationDateSelectHandler(date);
                          //     console.log(date)
                          //  }}
                        />
                      ) : (
                        <></>
                      )}

                      {value.fields.till_date ? (
                        <AddressCheckbox
                          name={`till_date_${caseCheckId}`}
                          id={`till_date_${caseCheckId}`}
                          fieldId={value.fields.till_date.ibridge_field_id}
                          label={value.fields.till_date.label}
                          isRequired={value.fields.till_date.is_mandatory}
                          errId={`err_${caseCheckId}_${value.fields.till_date.ibridge_field_id}`}
                          handleCheckboxChange={(e) => {
                                var cols = document.getElementById(`err_${caseCheckId}_${value.fields.till_date.ibridge_field_id}`);
                                cols.innerHTML = "";
                            handleCheckboxChange(e);
                          }}
                          checkDetailsIndex={key}
                          fieldName={"till_date"}
                          fieldValue={checkId == 57 ? true : value.fields.till_date.field_value}
                          disabled = {checkId == 57 ? true : false}
                          // hasError={errorData.till_date}
                        />
                      ) : (
                        <></>
                      )}

                      {/*
                                  {value.fields.till_date ?
                                  <ABDateAddress
                                  // paramStartDate={
                                  //   new Date()
                                  // }
                                  paramStartDate={null}
                                  placeholder="Till Date"
                                  name={`batchStart_${caseCheckId}`}
                                  id={`batchStart_${caseCheckId}`}
                                  fieldId={value.fields.till_date.id}
                                  isRequired={1}
                                  errId={`err_${caseCheckId}_${value.fields.till_date.id}`}
                                  intialStatus={0}
                                  dateSelect={selectHandler}
                                  // dateSelect={(date) => {
                                  //processConfirmationDateSelectHandler(date);
                                  //     console.log(date)
                                  //  }}
                                  />

                                  : <></>
                                  } */}
                    </div>

                    <div className="row">
                      {value.fields.pin_code ? (
                        <ABTextEdu
                          name={`pin_${caseCheckId}`}
                          id={`pin_${caseCheckId}`}
                          fieldId={value.fields.pin_code.id}
                          label="Pin code"
                          isRequired={value.fields.pin_code.is_mandatory}
                          errId={`err_${caseCheckId}_${value.fields.pin_code.id}`}
                          inputText={selectHandlerPin}
                          value={newRecord[value.fields.pin_code.id]}
                          caseCheckId={caseCheckId}
                          checkDetailsIndex={key}
                          fieldName="pin_code"
                        />
                      ) : (
                        <></>
                      )}

                      {value.fields.city ? (
                        <>
                          <ABTextEdu
                            name={`city_${caseCheckId}`}
                            id={`city_${caseCheckId}`}
                            fieldId={value.fields.city.id}
                            label="City"
                            isRequired={1}
                            errId={`err_${caseCheckId}_${value.fields.city.id}`}
                            inputText={selectHandler}
                            value={newRecord[value.fields.city.id]}
                            caseCheckId={caseCheckId}
                            checkDetailsIndex={key}
                            fieldName="city"
                          />

                          <input
                            type="hidden"
                            name={`city_${caseCheckId}` + "_value"}
                            id={`city_${caseCheckId}` + "_value"}
                            defaultValue={verificationSourceId}
                          />

                          {/* <input type="hidden" value={newRecord[value.fields.city.id]}/> */}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="row">
                      {value.fields.location ? (
                        <ABTextEdu
                          name={`state_${caseCheckId}`}
                          id={`state_${caseCheckId}`}
                          fieldId={value.fields.location.id}
                          label="State"
                          isRequired={1}
                          errId={`err_${caseCheckId}_${value.fields.location.id}`}
                          inputText={selectHandler}
                          value={newRecord[value.fields.location.id]}
                          checkDetailsIndex={key}
                          fieldName="location"
                        />
                      ) : (
                        <></>
                      )}

                      {value.fields.police_station ? (
                        <ABTextEdu
                          name={`policeStation_${caseCheckId}`}
                          id={`policeStation_${caseCheckId}`}
                          fieldId={value.fields.police_station.id}
                          label="Police Station"
                          isRequired={0}
                          errId={`err_${caseCheckId}_${value.fields.police_station.id}`}
                          inputText={selectHandler}
                          value={newRecord[value.fields.police_station.id]}
                          checkDetailsIndex={key}
                          fieldName="police_station"
                        />
                      ) : (
                        <></>
                      )}
                    </div>

                    <div className="row">
                      {value.fields.landmark_additional_address ? (
                        <ABTextEdu
                          name={`landMark_${caseCheckId}`}
                          id={`landMark_${caseCheckId}`}
                          fieldId={value.fields.landmark_additional_address.id}
                          label="Landmark Additional Details"
                          isRequired={
                            value.fields.landmark_additional_address
                              .is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.landmark_additional_address.id}`}
                          inputText={selectHandler}
                          value={
                            newRecord[
                              value.fields.landmark_additional_address.id
                            ]
                          }
                          checkDetailsIndex={key}
                          fieldName="landmark_additional_address"
                        />
                      ) : (
                        <></>
                      )}

                      {/* {showCountry == 1 && value.fields.country ?
                        (<>
                          <ABTextEdu
                            name={`country_${caseCheckId}`}
                            id={`country_${caseCheckId}`}
                            fieldId={value.fields.country.id}
                            label="Country"
                            isRequired={1}
                            errId={`err_${caseCheckId}_${value.fields.country.id}`}
                            inputText={selectHandler}
                            value={newRecord[value.fields.country.id]}


                          />
                        </>
                        )
                        : <></>
                      } */}

                      {value.fields.country && showCountry == 1 ? (
                        // {value.fields.country && newValidationRecord[`selectedOption_add_${caseCheckId}`] === "outside" ? (
                        <AddSimpleSelect
                          // name={`country_${caseCheckId}`}
                          // id={`country_${caseCheckId}`}
                          // label={value.fields.country.label}
                          // fieldId={value.fields.country.id}
                          // autoComplete="off"
                          // options={countries}
                          // isRequired={
                          //   value.fields.country.is_mandatory
                          // }
                          // caseCheckId={caseCheckId}
                          // handleSelectChange={selectHandler}
                          // checkDetailsIndex={key}
                          // fieldName={"country"}

                          // fieldValue={
                          //   value.fields.country.field_value
                          // }
                          //  errId={`err_${caseCheckId}_${value.fields.country.id}`}
                          // hasError={errorData.country}

                          type={
                            1
                          } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                          name={`country_${caseCheckId}`}
                          id={`country_${caseCheckId}`}
                          fieldId={value.fields.country.id}
                          placeholder="Select Country"
                          // autoComplete="off"
                          options={countryList}
                          // attachOther={true}
                          // verificationType={6}
                          selectOption={selectHandler}
                          isRequired={1}
                          errId={`err_${caseCheckId}_${value.fields.country.id}`}
                          caseCheckId={caseCheckId}
                          value={value.fields.country.field_value}
                          checkDetailsIndex={key}
                          fieldName={"country"}
                        />
                      ) : (
                        <></>
                      )}

                      {/* <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                              <div className="floating-label has-left-icon">
                              <input
                              type="text"
                              className="form-control"
                              name="houseNumber"
                              id="houseNumber"
                              onChange={handleFloatingLabels}
                              />
                              <label
                              htmlFor="houseNumber"
                              className={formData.houseNumber && "focused"}
                              >
                              Flat /House no/Floor/Building
                              <sup className="text-danger">*</sup>
                              </label>
                              </div>
                              </div>
                              </div> */}

                      {/* <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                              <div className="floating-label has-left-icon">
                              <input
                              type="text"
                              className="form-control"
                              name="colony"
                              id="colony"
                              onChange={handleFloatingLabels}
                              />
                              <label
                              htmlFor="colony"
                              className={formData.colony && "focused"}
                              >
                              Colony/Street/Locality
                              <sup className="text-danger">*</sup>
                              </label>
                              </div>
                              </div>
                              </div> */}
                    </div>
                    <div className="row">
                      {/* <div className="col-sm-4 col-md-12 col-xl-4">
                            <div className="form-group">
                            <div className="floating-label has-left-icon">
                            <input
                            type="text"
                            className="form-control"
                            name="landMark"
                            id="landMark"
                            onChange={handleFloatingLabels}
                            />
                            <label
                            htmlFor="landMark"
                            className={formData.landMark && "focused"}
                            >
                            Landmark / other Details
                            </label>
                            </div>
                            </div>
                            </div> */}
                      {/* <div className="col-sm-4 col-md-12 col-xl-4">
                            <div className="form-group">
                            <div className="floating-label has-left-icon">
                            <input
                            type="text"
                            className="form-control"
                            name="policeStation"
                            id="policeStation"
                            onChange={handleFloatingLabels}
                            />
                            <label
                            htmlFor="policeStation"
                            className={formData.policeStation && "focused"}
                            >
                            Police Station
                            </label>
                            </div>
                            </div>
                            </div> */}
                    </div>

                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-xl-8 mt-3 mb-1">
                        {newRecord[value?.fields?.address?.id] && (
                          <>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                rowGap: 8,
                                background: "#EFF8FF",
                                padding: 9,
                                borderRadius: 8,
                                border: "1px solid #D1E9FF",
                              }}
                            >
                              <h6 className="fnt-smi-bld mb-0">
                                Review Address Format
                              </h6>
                              <div>
                                {newRecord[value?.fields?.address?.id] && (
                                  <>{newRecord[value?.fields?.address?.id]}</>
                                )}
                                {newRecord[
                                  value?.fields?.colony_street?.id
                                ] && (
                                  <>
                                    ,{" "}
                                    {
                                      newRecord[
                                        value?.fields?.colony_street?.id
                                      ]
                                    }
                                  </>
                                )}
                                {newRecord[value?.fields?.city?.id] && (
                                  <>, {newRecord[value?.fields?.city?.id]}</>
                                )}
                                {newRecord[value?.fields?.location.id] && (
                                  <>
                                    , {newRecord[value?.fields?.location?.id]}
                                  </>
                                )}
                                {newRecord[value?.fields?.pin_code?.id] && (
                                  <>
                                    , {newRecord[value?.fields?.pin_code?.id]}
                                  </>
                                )}
                                {newRecord[
                                  value?.fields?.police_station?.id
                                ] && (
                                  <>
                                    <br></br>
                                    <strong>Police Station:</strong>{" "}
                                    {
                                      newRecord[
                                        value?.fields?.police_station?.id
                                      ]
                                    }
                                  </>
                                )}
                                {newRecord[
                                  value?.fields?.landmark_additional_address?.id
                                ] && (
                                  <>
                                    <br></br>
                                    <strong>Landmark:</strong>{" "}
                                    {
                                      newRecord[
                                        value?.fields
                                          ?.landmark_additional_address?.id
                                      ]
                                    }
                                  </>
                                )}
                                {newRecord[value?.fields?.country?.id] &&
                                showCountry == 1 ? (
                                  <>
                                    <br></br>
                                    <strong>Country:</strong>{" "}
                                    {countryList.map((countryListVal) => {
                                      if (
                                        countryListVal.value ==
                                        value?.fields?.country?.field_value
                                      ) {
                                        return <>{countryListVal.label}</>;
                                      }
                                    })}
                                  </>
                                ) : (
                                  <> </>
                                )}
                              </div>
                              <div>
                              <div style={{display: "flex", columnGap: 2, alignItems: "center", color : "#175CD3",fontSize: 14, fontWeight: 600, width: "fit-content"}} onClick={(e) => {
                                e?.preventDefault();
                                window.scroll({ top: 0, left: 0, behavior: "smooth" });
                              }}>
                                <FeatherIcon size={17} icon="edit" />{" "}
                                <Link style={{marginTop: 2}}>Edit Address</Link>
                              </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-xl-8 mt-1 mb-3">
                        <p style={{ fontSize: 14 }}>
                          *We may need to physically verify the address you
                          provided. Please ensure it is accurate
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-xl-8 mt-1 mb-3" style={{display: "flex", columnGap: 8, alignItems: "center"}}>
                      <input
                        type="checkbox"
                        className=""
                        id={`confirm_address_checkbox_${caseCheckId}`}
                        onChange={(e) => {
                          // console.log("checkid...",caseCheckId, e?.target?.checked);
                          setIsAddressConfirm((prevState) => ({
                            ...prevState,
                            [caseCheckId]: e?.target?.checked,
                          }));
                          document.getElementById(`error_confirm_address_checkbox_${caseCheckId}`).innerHTML =
                  "";
                        }}
                      />
                        <p style={{ fontSize: 16, fontWeight: 600, margin:"0px" }}>
                        I confirm the above address is correct.<sup className="text-danger">*</sup>
                        </p>
                      </div>
                    </div>
                    <p className="row err text-danger col-sm-12 col-md-12 col-xl-8 mt-1 mb-3" id={`error_confirm_address_checkbox_${caseCheckId}`}></p>

                    {/* <div className="row">
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                <div className="form-group">
                                <div className="floating-label has-left-icon">
                                <input
                                type="text"
                                className="form-control"
                                name="pinCode"
                                id="pinCode"
                                onChange={handleFloatingLabels}
                                />
                                <label
                                htmlFor="pinCode"
                                className={formData.pinCode && "focused"}
                                >
                                Pincode
                                </label>
                                </div>
                                </div>
                                </div>
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                <div className="form-group">
                                <div className="floating-label has-left-icon">
                                <input
                                type="text"
                                className="form-control"
                                name="city"
                                id="city"
                                onChange={handleFloatingLabels}
                                />
                                <label
                                htmlFor="city"
                                className={formData.city && "focused"}
                                >
                                City
                                </label>
                                </div>
                                </div>
                                </div>
                                </div> */}
                    {/* <div className="row">
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                <div className="form-group">
                                <div className="floating-label has-left-icon">
                                <input
                                type="text"
                                className="form-control"
                                name="state"
                                id="state"
                                onChange={handleFloatingLabels}
                                />
                                <label
                                htmlFor="state"
                                className={formData.state && "focused"}
                                >
                                State
                                </label>
                                </div>
                                </div>
                                </div>
                                </div> */}
                    {value.required_documents &&
                      value.required_documents[0] && (
                        <h6 className="fnt-smi-bld mb-0">Upload Files</h6>
                      )}

                    {/* <small className="text-muted">
                              upload one of following : Electricity Bill, Phone Bill,
                              Voter ID , Adhaar Card
                              </small> */}

                    {value.required_documents &&
                      Object.entries(value.required_documents).map(
                        ([key, value]) => {
                          if (key == 0) {
                            return (
                              <>
                                {address?.clientId == 387715 && (
                                  <p style={{ color: "red" }}>
                                    Acceptable document types - Driving License
                                    ,Voter card or Passport
                                  </p>
                                )}
                                <ABUploadAdd
                                  name={value.id}
                                  id={value.id}
                                  title={value.document_name}
                                  record={{
                                    caseCheckId:
                                      active !== null && active !== undefined
                                        ? active
                                        : caseCheckId,
                                    docId: value.id,
                                  }}
                                  totalCount={
                                    uploadedFilesCount[parseInt(index - 1)] &&
                                    uploadedFilesCount[parseInt(index - 1)][
                                      value.id
                                    ]
                                      ? uploadedFilesCount[parseInt(index - 1)][
                                          value.id
                                        ]
                                      : 0
                                  }
                                  // errorCheck={errorCheck}
                                  isRequired={
                                    documnetMandatory[parseInt(index - 1)][
                                      value.id
                                    ]
                                  }
                                  // getCount={doc371Count}
                                  reRenderAgain={reRenderAgain}
                                />

                                <input
                                  type="hidden"
                                  name={`document_${value.id}_count_${caseCheckId}`}
                                  id={`document_${value.id}_count_${caseCheckId}`}
                                  value={
                                    uploadedFilesCount[parseInt(index - 1)] &&
                                    uploadedFilesCount[parseInt(index - 1)][
                                      value.id
                                    ]
                                      ? uploadedFilesCount[parseInt(index - 1)][
                                          value.id
                                        ]
                                      : 0
                                  }
                                  data-mandatory={
                                    documnetMandatory[parseInt(index - 1)][
                                      value.id
                                    ]
                                  }
                                />

                                <p
                                  className="err text-danger"
                                  id={`err_document_${value.id}_count_${caseCheckId}`}
                                ></p>
                              </>
                            );
                          }
                        }
                      )}

                    {/* {(() => {

                      if (checkId == 57) {



                        return (
                          <>
                            <ABUploadAdd
                              name="address_proof"
                              id="address_proof"
                              title="Address Proof"
                              record={{ "caseCheckId": caseCheckId, docId: 366 }}
                              totalCount={
                                uploadedFilesCount[parseInt(index - 1)] &&
                                  uploadedFilesCount[parseInt(index - 1)][366]
                                  ? uploadedFilesCount[parseInt(index - 1)][366]
                                  : 0
                              }
                              errorCheck={errorCheck}
                              // isRequired={1}
                              // getCount={doc371Count}
                              reRenderAgain={reRenderAgain}

                            />

                            {console.log(errorMessage)}
                            <input type="hidden" name={`document_366_count_${caseCheckId}`} id={`document_366_count_${caseCheckId}`} value={
                              uploadedFilesCount[parseInt(index - 1)] &&
                                uploadedFilesCount[parseInt(index - 1)][366]
                                ? uploadedFilesCount[parseInt(index - 1)][366]
                                : 0
                            } data-mandatory={documnetMandatory[parseInt(index - 1)][366]} />

                            <p className="err text-danger" id={`err_document_366_count_${caseCheckId}`} ></p>

                          </>
                        );


                        // else {
                        //   return (

                        //   );
                      } else {

                        return (
                          <>
                            <ABUploadAdd
                              name="address_proof"
                              id="address_proof"
                              title="Address Proof"
                              record={{ "caseCheckId": caseCheckId, docId: 387 }}
                              totalCount={
                                uploadedFilesCount[parseInt(index - 1)] &&
                                  uploadedFilesCount[parseInt(index - 1)][387]
                                  ? uploadedFilesCount[parseInt(index - 1)][387]
                                  : 0
                              }
                              errorCheck={errorCheck}
                              // isRequired={1}
                              // getCount={doc371Count}
                              reRenderAgain={reRenderAgain}
                            />

                            <input type="hidden" name={`document_387_count_${caseCheckId}`} id={`document_387_count_${caseCheckId}`} value={
                              uploadedFilesCount[parseInt(index - 1)] &&
                                uploadedFilesCount[parseInt(index - 1)][387]
                                ? uploadedFilesCount[parseInt(index - 1)][387]
                                : 0
                            } data-mandatory={documnetMandatory[parseInt(index - 1)][387]} />

                            <p className="err text-danger" id={`err_document_387_count_${caseCheckId}`} ></p>
                          </>
                        )
                      }


                    })()} */}

                    {/* <ABUpload
                      name="address_proof"
                      id="address_proof"
                      title="Address Proof"
                      record={{ "caseCheckId": caseCheckId, docId: 346 }}
                      getCount={doc346Count}
                      reRenderAgain={reRenderAgain}
                    /> */}

                    {/* <div className="row mt-3">
                              <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                              <div className="floating-label">
                              <select
                              defaultValue=""
                              name="documentType"
                              id="documentType"
                              className="form-control"
                              onChange={handleFloatingLabels}
                              >
                              <option value=""></option>
                              <option value="Hi">Hi</option>
                              </select>
                              <label
                              htmlFor="documentType"
                              className={formData.documentType && "focused"}
                              >
                              Select Document Type
                              </label>
                              </div>
                              </div>
                              </div>
                              </div> */}
                    {/* <div className="row">
                              <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="upload-box">
                              <div className="left d-flex align-items-center">
                              <img
                              src={TickIconBlack}
                              className="mr-2 pl-3 pr-3"
                              alt=""
                              />
                              <span>
                              <h6 className="m-0">Bill-2012.. jpg</h6>
                              <small className="text-muted">
                              1 Files uploaded
                              </small>
                              </span>
                              </div>
                              <div className="right text-right">
                              <img
                              src={CrossIcon}
                              alt=""
                              className="remove-btn"
                              />
                              </div>
                              </div>
                              </div>
                              </div> */}

                    {/* <div className="row mt-3">
                              <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="upload-box">
                              <div className="left d-flex align-items-center">
                              <img src={UploadIcon} className="mr-2" alt="" />
                              <span>
                              <h6 className="m-0">Upload file</h6>
                              <small className="text-muted">
                              Click to upload
                              </small>
                              </span>
                              </div>
                              <div className="right text-right">
                              <img
                              src={ArrowRightIcon}
                              alt=""
                              className="remove-btn"
                              />
                              </div>
                              </div>
                              </div>
                              </div> */}

                    {/* <div className="row mt-3">
                              <div className="col-auto">
                              <button className="btn btn-outline-primary">
                              + Upload another
                              </button>
                              </div>
                              </div> */}
                  </div>
                </>

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Back
                    </button> */}
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) =>
                        saveHandler(e, caseCheckId, index, checkId)
                      }
                    >
                      Save
                    </button>
                  </div>
                </div>
                {showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </div>
            );
          })}

        {/* <div
                    className="tab-pane fade"
                    id="permanent-address"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="sameAddress"
                      />
                      <label htmlFor="sameAddress" className="form-check-label">
                        Same as Current Address
                      </label>
                    </div>
                    <div className="row mt-3">
                      <div className="col-auto d-flex justify-content-between">
                        <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                          Back
                        </button>
                        <button className="btn btn-primary btn-lg btn-block mt-3">
                          Save
                        </button>
                      </div>
                    </div>
                  </div> */}
      </div>

      {/* <p onClick={openModal}>
                            <i class="fas fa-pen text-primary"></i>
                          </p> */}

      {/* <CustomPopUp
       showModalBox={showModal}
        closePopup={closeModal}
        /> */}

      {/* <div className="dashboard custom-modal-dialog show" id="">
        <div className="modal-wrapper">
          <div className="modal-content p-4">
          <ShowCarousel closeModal={setOpenModalMarksheet}/>
          </div>
        </div>
      </div> */}
      {/* <div className="dashboard custom-modal-dialog ">
        <div className="modal-wrapper">
          <div className="modal-content p-4 no-scroll" style={{maxWidth: '370px'}}>
            <div className="text-left">
              <img src={ExclamationIcon} alt=""/>
              <h5 className="mt-3">Delete Address</h5>
              <p className="text-muted">Are you sure you want to delete this address? This action cannot be undone.</p>
            </div>
            <div className="row">
              <div className="col-md-12 d-flex justify-content-between">
                <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Cancel</button>
                <button className="btn btn-danger btn-lg btn-block mt-3">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};
export default MainForm;
